import { render, staticRenderFns } from "./confirm-mail-2.vue?vue&type=template&id=b48e73b2&scoped=true&"
import script from "./confirm-mail-2.vue?vue&type=script&lang=js&"
export * from "./confirm-mail-2.vue?vue&type=script&lang=js&"
import style0 from "./confirm-mail-2.vue?vue&type=style&index=0&id=b48e73b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e73b2",
  null
  
)

export default component.exports